import { Modal, Form, Row, Col } from "react-bootstrap";
import FloatingLabelInput from "../Generic/FloatingLabelInput";

const ExperienceModal = ({
  show,
  onHide,
  expForm,
  setExpForm,
  onSave,
  expModalIndex,
  loading,
}) => {
  const handleChange = (field, value) => {
    setExpForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    await onSave();
  };

  return (
    <Modal
      show={show}
      onHide={loading ? () => {} : onHide}
      backdrop={loading ? "static" : true}
      keyboard={!loading}
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {expModalIndex !== null ? "Edit Experience" : "Add Experience"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="required-hint">
          * Required fields are marked with an asterisk
        </p>

        <Form>
          <Form.Group className="mb-3">
            <FloatingLabelInput
              label="Organization Name *"
              type="text"
              value={expForm.companyName}
              onChange={(e) => handleChange("companyName", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <FloatingLabelInput
              label="Position *"
              type="text"
              value={expForm.jobTitle}
              onChange={(e) => handleChange("jobTitle", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <FloatingLabelInput
              label="Industry"
              type="text"
              value={expForm.industry}
              onChange={(e) => handleChange("industry", e.target.value)}
            />
          </Form.Group>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <FloatingLabelInput
                  label="Starting Date *"
                  type="date"
                  value={expForm.startDate}
                  onChange={(e) => handleChange("startDate", e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <FloatingLabelInput
                  label="Ending Date"
                  type="date"
                  disabled={expForm.current}
                  value={expForm.endDate}
                  onChange={(e) => handleChange("endDate", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Check
            className="mb-3"
            type="checkbox"
            checked={expForm.current}
            label="I currently work here"
            onChange={(e) => handleChange("current", e.target.checked)}
          />

          <Form.Group className="mb-3">
            <FloatingLabelInput
              label="Years of Experience (Tech)"
              type="number"
              min={0}
              step={1}
              value={expForm.yearsInTech}
              onChange={(e) => {
                const value = Math.max(0, Number(e.target.value) || 0);
                handleChange("yearsInTech", value.toString());
              }}
            />
          </Form.Group>

          <Form.Check
            className="mt-3"
            type="checkbox"
            checked={expForm.canGiveReferral ?? true}
            label="I can give referrals"
            onChange={(e) => handleChange("canGiveReferral", e.target.checked)}
          />
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex gap-2 justify-content-end w-100">
          <button
            type="button"
            className="auth-btn-compact auth-btn-secondary"
            onClick={onHide}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            className="auth-btn-compact bg-primary text-white"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ExperienceModal;
